var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big-box" },
    _vm._l(_vm.navList, function(item, index) {
      return _c("div", { key: index, staticClass: "list-item" }, [
        _c(
          "div",
          {
            staticClass: "first-item flexSpace first-item-name displayIB",
            on: {
              click: function($event) {
                return _vm.goNav(item, index)
              }
            }
          },
          [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
        ),
        index + 1 < _vm.navList.length
          ? _c("div", { staticClass: "first-item-hr" })
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4b6ca22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4b6ca22","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopMainNav/TopMainNav.vue
// module id = 439
// module chunks = 25